export const CommonConstant = {
    SAVE: "Save",
    EDIT: "Edit",
    UPDATE: "Update",
    CANCEL: "Cancel",
    NEXT: "Next",
    PREVIOUS: "Previous",
    FINISH: "Finish",
    SR: "SR.",
    STATUS: "Status",
    ACTION: "Action",
    DETAILS: "Details",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    NoRecordFound: "No Record Found.",
    FileNotFound: "File Not Found",
    UPLOAD: "Upload",
    ADD: "Add",
    PENDING:"Pending",
    FILEFORMAT: "['image/jpeg', 'image/jpg','image/png','image/bmp']"
}

export const DateFormate = {
    DATE: 'dd-MM-yyyy',
    TIME: 'hh:mm a',
    DATE_TIME: 'dd/MM/yyyy hh:mm:ss a'
}

export const NoRecordFound = {
    NoStudentFound: "No student record(s) found.",
    NoCollegeBatchFound: "No college batch record(s) found.",
    NoQuestionSetFound: "No question set record(s) found.",
    NoQuestionFound: "No question record(s) found.",
    NoExamFound: "No exam record(s) found.",
    NoJobFound: "No job record(s) found.",
    NoUserFound: "No user record(s) found.",
    NoCompanyFound: "No company record(s) found.",
    NoCompanyUserFound: "No company user record(s) found.",
    NoCollegeFound: "No college record(s) found.",
    NoStudenrResultFound: "No student result record(s) found.",
    NoReportProblemFound: "No report problem record(s) found.",
    NoOneHasApplyYetFound: "No one has applied yet.",
    NoParentTechnologyFound: "No Parent Technology found.",
    NoPendingStudentRecordFound: "No pending student record(s) found."
}

export const TestResult = {
    Background : "Background",
    Submit : "Submitted",
    Timeout : "Timeout",
    ReSubmission : "ReSubmission",
    Start : "Started"
}

export const ExamStudentList = {
    StudentName :"Student Name",
    EmailId :"Email Address",
    MobileNo :"Mobile No.",
    BatchName: "Batch Name",
    BatchYear :"Batch Year",
    CollegeName :"College Name",
    CollegeCode :"College Code"
}